/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { FunctionComponent, useEffect, useRef } from "react";
import { selectSKUPromotion } from "../../../selectors/products";
import { PromoLabel } from "../promotions/promo-label/PromoLabel";
import Select, { Option } from "rc-select";
import { getSkuWithNumber } from "../../../selectors/productPage";
import { FormatProductPackaging } from "../../atoms/helper/FormatProductPackaging";
import {
  IPackaging,
  IVariation
} from "../../../interfaces/my-puratos/IGeneric";

interface IProps {
  onChange: (n: number) => void;
  selected: number;
  skus: Array<IPackaging>;
  variations: Array<IVariation>;
}

export const PackagingSelector: FunctionComponent<IProps> = ({
  skus,
  variations = undefined,
  selected,
  onChange
}) => {
  const ref = useRef();

  useEffect(() => {
    if (selected === undefined || selected === -1) {
      onChange(0);
    }
  }, [variations]);

  return (
    <div style={{ position: "relative" }}>
      <Select
        className={"p-select form-control p-select--custom"}
        value={selected}
        onChange={onChange}
        getPopupContainer={() => ref.current}
        dropdownClassName="p-select--custom__dropdown"
      >
        {variations?.map(variation => (
          <Option
            key={variation.materialNumber}
            value={parseInt(variation.materialNumber)}
          >
            {variation.packaging}{" "}
            <span className={"p-select--custom__badge pull-right"}>
              {skus &&
              selectSKUPromotion(
                getSkuWithNumber(skus, variation.materialNumber),
                null
              ) ? (
                <PromoLabel
                  code={
                    selectSKUPromotion(
                      getSkuWithNumber(skus, variation.materialNumber),
                      {}
                    ).promoCode
                  }
                />
              ) : null}
            </span>
          </Option>
        ))}
        {!variations &&
          skus?.map(sku => (
            <Option key={sku.materialNumber} value={sku.materialNumber}>
              {<FormatProductPackaging sku={sku} />}
              <span className={"p-select--custom__badge pull-right"}>
                {selectSKUPromotion(
                  getSkuWithNumber(skus, sku.materialNumber),
                  null
                ) ? (
                  <PromoLabel
                    code={
                      selectSKUPromotion(
                        getSkuWithNumber(skus, sku.materialNumber),
                        {}
                      ).promoCode
                    }
                  />
                ) : null}
              </span>
            </Option>
          ))}
      </Select>
      <div ref={ref} />
    </div>
  );
};
